<template>
  <Section :title="title">
    <div class="grid grid--large grid--multiline">
      <div class="grid__item md-w-1/2">
        <FormGroup
          :field="consumptionField"
          :help="light ? null : consumptionHelp"
          :errors="consumptionErrors"
        >
          <div class="field-group">
            <Input
              v-model="tempConsumptionValue"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <div class="field-group__addon">
              kilowattheures <small class="text-muted">(kWh)</small>
            </div>
          </div>
        </FormGroup>
      </div>
      <div v-if="withPower" class="grid__item md-w-1/2">
        <FormGroup :field="powerField" :errors="powerErrors">
          <div class="field-group">
            <Input
              v-model="tempPowerValue"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <div class="field-group__addon">
              kilowatts <small class="text-muted">(KW)</small>
            </div>
          </div>
        </FormGroup>
      </div>
    </div>
  </Section>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import Section from '@/components/simulation/Section.vue';
import FormGroup from '@/components/forms/FormGroup.vue';
import Input from '@/components/forms/fields/Input.vue';
import { useSimulation } from '@/composables/useSimulation';

defineProps({
  withPower: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: gettext('Quelle est votre consommation de gaz naturel-biogaz?'),
  },
  light: {
    type: Boolean,
    default: false,
  },
});

const powerErrors = ref([]);
const consumptionErrors = ref([]);

const tempConsumptionValue = ref(null);
const tempPowerValue = ref(null);

const { simulation, usageId, updateSimulation, consumptionField } =
  useSimulation();

if (simulation.consumption) {
  tempConsumptionValue.value = Math.floor(simulation.consumption);
}
if (simulation.power) {
  tempPowerValue.value = Math.floor(simulation.power);
}

const powerField = computed(() => {
  return {
    label: gettext('Puissance de l’installation'),
    name: 'power',
    required: true,
  };
});

const consumptionHelp = computed(() => {
  if (usageId.value === 'cooking') {
    return gettext(
      'En moyenne, pour une cuisson au gaz naturel-biogaz, la consommation annuelle d’une famille est de 800 kWh, et celle d’un restaurant de 10’000 kWh.'
    );
  } else if (usageId === 'industrial') {
    return gettext(
      'La consommation annuelle moyenne pour une usine est de 100’000 KWh'
    );
  }
  return null;
});

watch(tempPowerValue, (value) => {
  powerErrors.value = [];
  const power = parseInt(value);

  /* eslint-disable-next-line eqeqeq */
  if (isNaN(power) || power != value) {
    powerErrors.value.push(gettext('Doit être un nombre.'));
    updateSimulation({ power: null });
    return;
  }
  updateSimulation({ power });
});

watch(tempConsumptionValue, (value) => {
  consumptionErrors.value = [];
  const consumption = parseInt(value);

  /* eslint-disable-next-line eqeqeq */
  if (isNaN(consumption) || consumption != value) {
    consumptionErrors.value.push(gettext('Doit être un nombre.'));
    updateSimulation({ consumption: null });
    return;
  }
  updateSimulation({ consumption });
});
</script>
